import { createSelector } from 'reselect';
import { RootState } from '../rootReducer';
import { EventsState } from './events.types';

const selectEventsState = (state: RootState): EventsState => state.events;

export const selectEvents = createSelector(
  [selectEventsState],
  (eventsState) => eventsState.events
);

export const selectEventsLoading = createSelector(
  [selectEventsState],
  (eventsState) => eventsState.loading
);

export const selectEventsError = createSelector(
  [selectEventsState],
  (eventsState) => eventsState.error
);

export const selectSendEventLoading = createSelector(
  [selectEventsState],
  (eventsState) => eventsState.sendEventLoading
);

export const selectSendEventError = createSelector(
  [selectEventsState],
  (eventsState) => eventsState.sendEventError
);
